<script setup>
defineProps({
    type: {
        type: String,
        default: "submit",
    },
    isProcessing: {
        type: Boolean,
        default: false,
    },
});

const emits = defineEmits(["onCLickSubmit"]);

const onClick = () => {
    emits("onCLickSubmit", true);
};
</script>

<template>
    <button
        :type="type"
        :disabled="isProcessing"
        class="btn text-white btn-padding-auth bg-danger border-black-1 rounded-06 px-5"
        @click="onClick"
    >
        <slot />
        <div
            class="spinner-border spinner-border-sm ms-2"
            output="status"
            v-if="isProcessing"
        >
            <span class="visually-hidden">Loading...</span>
        </div>
    </button>
</template>

<style>
.btn-padding-auth {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
}
</style>
